/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { Box, Inline, Text } from '@atlaskit/primitives';
import { RovoLogo } from '@atlassian/conversation-assistant-ui-components';
import { AtlassianIntelligenceLogo } from '../../AtlassianIntelligenceLogo/AtlassianIntelligenceLogo';
import messages from '../messages';
export function FooterAIBrand(_ref) {
  var brand = _ref.brand,
    appearance = _ref.appearance;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var shortDisclaimer = brand === 'rovo' ? messages.rovoCopyright : messages.atlassianIntelligenceCopyrightShort;
  var fullDisclaimer = brand === 'rovo' ? messages.rovoCopyright : messages.atlassianIntelligenceCopyright;
  return jsx(Inline, null, appearance !== 'small' && jsx(Box, null, appearance === 'medium' ? jsx(Text, {
    size: "small",
    color: "color.text.subtlest"
  }, formatMessage(shortDisclaimer)) : jsx(Text, {
    size: "small",
    color: "color.text.subtlest"
  }, formatMessage(fullDisclaimer))), brand === 'rovo' ? jsx(RovoLogo, {
    label: formatMessage(fullDisclaimer),
    primaryColor: "var(--ds-icon-subtle, #626F86)"
  }) : jsx(AtlassianIntelligenceLogo, {
    label: formatMessage(fullDisclaimer),
    primaryColor: "var(--ds-icon-subtle, #626F86)"
  }));
}